define('models/OrderCollection',['underscore', 'ObjectCollection', 'LocalStorage', 'models/OrderModel','app'], function (_, ObjectCollection, LocalStorage, OrderModel,app)
{
    //
    // Collection Order
    //
    var CENTURY_IN_MS = 1000 * 60 * 60 * 24 * 365.25 * 100;

    var OrderCollectionPrototype = {

        name: 'OrderCollection',
        route: 'apiOrderCollection',
        model: OrderModel,
        //privateApi:true,

        initialize: function ()
        {
            // ObjectCollection constructor heritage
            var collection = this;
            ObjectCollection.prototype.initialize.apply(collection, arguments);
            //
            collection.on('sync', collection.onSync, collection);
            //
        },

        setComparatorReorder:function(){
            var collection = this;
            collection.comparator = function(order){
                var size = collection.size(),
                    date = order.getMoment(),
                    fromNow = date.diff(),
                    fromNowCentury = 1-(fromNow/CENTURY_IN_MS),
                    isNowService = order.isNowService() ? 0 : 1*size;
                return isNowService + fromNowCentury;
            };
            collection.sort();
        },

        filterReorder:function(){
            return this.where({reorder_available:true});
        },

        getLastOrder:function(){
            return this.first();
        },
        getOrderById: function (orderId) {
            return this.getLastOrder()
        }

    };

    var OrderCollection = ObjectCollection.extend(LocalStorage).extend(OrderCollectionPrototype);

    return OrderCollection;
});
